import React from 'react';
import { UnAuthorizedPage } from '../components/primary/unAuthorizedPage'
export const UnAuthorizedContent = () => {
  return (
    <>
      <UnAuthorizedPage />
    </>
  )
}
